// Custom packages
import { isArchiveV3Live } from "src/app/shared/utils/archive-switch.utils";

/**
 * The titles of the 3.0.0 archive pages once the archive is live (FE-A1).
 *
 * Until the switch the new pages are reachable by address only, and their titles carry «(nuove
 * collection)» so that whoever opens one knows which archive is on screen. Once the archive is live
 * they are THE archive pages: each title drops the mark and reads the text already written, without
 * it, under another key — the title of the legacy page, of its card or of its side-menu entry — so that
 * no text is added to it.json and en.json, which ship in the initial bundle.
 *
 * The editor of the archive in «Impostazioni» follows the same rule with the mark «(nuovo)»: until the
 * switch its entry stands in the menu next to the legacy editor, «Archivio», and once the archive is
 * live it takes that name and the title of that page, the legacy entry being gone (FEX-27).
 *
 * Keyed by the 3.0.0 key, valued with the key read once the archive is live. The 3.0.0 keys and this
 * table go after the switch (FEX-28).
 *
 * @since 3.0.0
 */
export const ARCHIVE_V3_LIVE_TITLES: { readonly [v3Key: string]: string } = {
  "properties.documentsV3.pageTitle": "properties.documentsPage.documentsTab.title",
  "properties.documentsV3.cardTitle": "properties.documentsPage.documentsTab.title",
  "properties.searchV3.pageTitle": "properties.searchPage.pageTitle",
  "searchDocs.v3.pageTitle": "properties.searchPage.pageTitle",
  "properties.documents.summaryDocs.v3.pageTitle": "sidenav.summaryDocs",
  "properties.documents.nextInsertions.v3.pageTitle": "sidenav.nextInsertions",
  "deletedDocs.v3.list.pageTitle": "deletedDocs.list.pageTitle",
  "deadlines.v3.pageTitle": "deadlines.documentsList.pageTitle",
  "deadlines.v3.propertyPageTitle": "properties.home.btns.listOfDocumentsWithExpiration",
  "deadlines.v3.propertyListTitle": "companies.detail.deadlinesTab.title",
  "historicalDocs.v3.pageTitle": "historicalDocs.list.pageTitle",
  "historicalDocs.v3.propertyListTitle": "historicalDocs.list.listTab.title",
  "sidenav.setting_documentTemplate": "sidenav.setting_document",
  "settings.documentTemplate.pageTitle": "settings.document.pageTitle",
};

/**
 * The translation key of a title of a 3.0.0 archive page: the key itself until the archive is live,
 * the key of the same text without «(nuove collection)» or «(nuovo)» once it is
 * (@see ARCHIVE_V3_LIVE_TITLES).
 * A key the table does not hold is returned as it is.
 *
 * @since 3.0.0
 *
 * @param key  The 3.0.0 key the page writes
 * @param live Whether the archive is live: this build's, unless a test says otherwise
 */
export function archiveV3Title(key: string, live: boolean = isArchiveV3Live()): string {
  if (!live || !Object.prototype.hasOwnProperty.call(ARCHIVE_V3_LIVE_TITLES, key)) {
    return key;
  }
  return ARCHIVE_V3_LIVE_TITLES[key];
}
